import {
  ActionMenuItem,
  NavItem,
  PlatformKeys,
  SocialKeys,
  Socials,
} from "@kelp-dao/kernel-design-system";
import {
  BookIcon,
  BridgeIcon,
  ChartPieIcon,
  CubeIcon,
  DotsThreeVerticalIcon,
  DropHalfIcon,
  GavelIcon,
  GithubLogoIcon,
  GraphIcon,
  HandArrowDownIcon,
  NewspaperIcon,
  PaintBrushIcon,
  ScrollIcon,
  // SealWarningIcon,
  ShieldWarningIcon,
} from "@phosphor-icons/react";
import { FAVICONS, ICONS, LOGOS } from "public/assetsV2/images";
import { HEADER_NAV_CLICK, PRODUCT_DROPDOWN_CTA } from "@constants/analytics";
import { trackEvent } from "utils";

export const useKelpNavItems = (): NavItem[] => {
  return [
    {
      label: "Products",
      skipLabelInMobile: true,
      skipInDesktop: true,
      submenu: [
        {
          label: "Kelp",
          description: "Restaked ETH. Routed across 10+ L2s.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/kelp`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Kelp.src}
              alt="Kelp"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Kelp",
              location: "header",
            });
          },
        },
        {
          label: "Gain",
          description:
            "No lockups. No thresholds. Just vaults that don't sleep.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/gain`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Gain.src}
              alt="Gain"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Gain",
              location: "header",
            });
          },
        },
        {
          label: "Kernel",
          description: "Restake BNB, BTC & more. Secure 25+ protocols.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/kernel`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Kernel.src}
              alt="Kernel"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Kernel",
              location: "header",
            });
          },
        },
      ],
    },

    {
      label: "Governance",
      submenu: [
        {
          icon: (
            <img
              src={ICONS.KernelStakeIcon.src}
              alt="Kernel"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          label: "Stake $KERNEL",
          description: "Participate in KernelDAO Governance",
          href: "https://kerneldao.com/stake/",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "Governance",
              label: "Stake $KERNEL",
              destination_url: "https://kerneldao.com/stake/",
              location: "header",
            });
          },
        },
        {
          icon: (
            <ScrollIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          label: "Forum",
          description: "Discuss & debate on proposals",
          href: "https://forum.kerneldao.com/t/welcome-to-kerneldao-governance-forum/5",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "Governance",
              label: "Forum",
              destination_url:
                "https://forum.kerneldao.com/t/welcome-to-kerneldao-governance-forum/5",
              location: "header",
            });
          },
        },
        {
          icon: (
            <GavelIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          label: "Vote",
          description: "Use your voting power to shape KERNELDAO",
          href: "https://snapshot.box/#/s:kernelgov.eth",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "Governance",
              label: "Vote",
              destination_url: "https://snapshot.box/#/s:kernelgov.eth",
              location: "header",
            });
          },
        },
      ],
      submenuLayout: "double",
    },
    {
      label: "Blogs",
      href: "https://blogs.kerneldao.com/",
      description: "Read our latest news and updates.",
      icon: (
        <NewspaperIcon
          weight="fill"
          color="black"
          className="w-4 h-4 lg:w-6 lg:h-6"
        />
      ),
      sendEvent: () => {
        trackEvent("lp_header_nav_click", {
          event_type: "button_click",
          event_category: "Landing",
          category: "Blogs",
          label: "Blogs",
          destination_url: "https://blogs.kerneldao.com/",
          location: "header",
        });
      },
    },
    {
      label: "Ecosystem",
      href: "https://kerneldao.com/ecosystem/",
      description: "Explore our ecosystem and community.",
      icon: (
        <GraphIcon
          weight="fill"
          color="black"
          className="w-4 h-4 lg:w-6 lg:h-6"
        />
      ),
      sendEvent: () => {
        trackEvent("lp_header_nav_click", {
          event_type: "button_click",
          event_category: "Landing",
          category: "Ecosystem",
          label: "Ecosystem",
          destination_url: "https://kerneldao.com/ecosystem/",
          location: "header",
        });
      },
    },
    {
      label: "More",
      skipLabelInMobile: true,
      submenuLayout: "double",
      submenu: [
        {
          label: "Litepaper",
          description: "Read our approach to restaking.",
          icon: (
            <ScrollIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          section: "Insights",
          href: "https://kerneldao.gitbook.io/litepaper",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "More",
              label: "Litepaper",
              destination_url: "https://kerneldao.gitbook.io/litepaper",
              location: "header",
            });
          },
        },
        {
          label: "Docs",
          description: "Technical documentation and guides.",
          icon: (
            <BookIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          section: "Insights",
          href: "https://kerneldao.gitbook.io/kernel",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "More",
              label: "Docs",
              destination_url: "https://kerneldao.gitbook.io/kernel",
              location: "header",
            });
          },
        },
        {
          label: "Brandkit",
          description: "Logos and everything you need.",
          icon: (
            <PaintBrushIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          section: "Developers",
          href: "https://kerneldao.com/brand-kit/",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "More",
              label: "Brandkit",
              destination_url: "https://kerneldao.com/brand-kit/",
              location: "header",
            });
          },
        },
        {
          label: "Github",
          description: "Explore our open-source code.",
          icon: (
            <GithubLogoIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          section: "Developers",
          href: "https://github.com/Kelp-DAO/kernel-smart-contracts-public",
          sendEvent: () => {
            trackEvent("lp_header_nav_click", {
              event_type: "button_click",
              event_category: "Landing",
              category: "More",
              label: "Github",
              destination_url:
                "https://github.com/Kelp-DAO/kernel-smart-contracts-public",
              location: "header",
            });
          },
        },
      ],
      submenuFooter: (
        <Socials
          platformIconWidth={12}
          platformIconHeight={12}
          size={24}
          socials={[
            {
              key: SocialKeys.TWITTER,
              link: "https://x.com/kernel_dao",
              platformKey: PlatformKeys.KERNEL,
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "x",
                  location: "header",
                  destination_url: "https://x.com/kernel_dao",
                });
              },
            },
            {
              key: SocialKeys.TWITTER,
              link: "https://x.com/KelpDAO",
              platformKey: PlatformKeys.KELP,
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "x",
                  location: "header",
                  destination_url: "https://x.com/KelpDAO",
                });
              },
            },
            {
              key: SocialKeys.DISCORD,
              link: "https://discord.gg/khSpqCFvGq",
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "discord",
                  location: "header",
                  destination_url: "https://discord.gg/khSpqCFvGq",
                });
              },
            },
            {
              key: SocialKeys.TELEGRAM,
              link: "https://t.me/KelpDAOxyz/",
              sendEvent: () => {
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "telegram",
                  location: "header",
                  destination_url: "https://t.me/KelpDAOxyz/",
                });
              },
            },
          ]}
        />
      ),
    },
  ];
};

export const useKelpAppNavItems = (): NavItem[] => {
  return [
    {
      label: "Products",
      skipLabelInMobile: true,
      skipInDesktop: true,
      submenu: [
        // {
        //   label: "Kelp",
        //   description: "Restaked ETH. Routed across 10+ L2s.",
        //   skipDescriptionInMobile: true,
        //   href: `https://kerneldao.com/kelp`,
        //   external: true,
        //   icon: (
        //     <img
        //       src={FAVICONS.Kelp.src}
        //       alt="Kelp"
        //       className="w-4 h-4 lg:w-6 lg:h-6"
        //     />
        //   ),
        //   sendEvent: () => {
        //     trackEvent("lp_product_selected", {
        //       event_type: "button_click",
        //       event_category: "Landing",
        //       event_label: "Kelp",
        //       location: "header",
        //     });
        //   },
        // },
        {
          label: "Gain",
          description:
            "No lockups. No thresholds. Just vaults that don't sleep.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/gain`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Gain.src}
              alt="Gain"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Gain",
              location: "header",
            });
          },
        },
        {
          label: "Kernel",
          description: "Restake BNB, BTC & more. Secure 25+ protocols.",
          skipDescriptionInMobile: true,
          href: `https://kerneldao.com/kernel`,
          external: true,
          icon: (
            <img
              src={FAVICONS.Kernel.src}
              alt="Kernel"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent("lp_product_selected", {
              event_type: "button_click",
              event_category: "Landing",
              event_label: "Kernel",
              location: "header",
            });
          },
        },
      ],
    },
    {
      label: "Liquid restaking",
      submenu: [
        {
          label: "Restake",
          description: "Deposit ETH, stETH or ETHx & earn rewards",
          href: "/restake",
          icon: (
            <DropHalfIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
        },
        {
          label: "Bridge & wrap",
          description:
            "Move your tokens across chains, without losing usability.",
          href: "/bridge-wrap",
          icon: (
            <BridgeIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
        },
        {
          label: "AVS",
          description: "Actively validated services",
          href: "/avs",
          icon: (
            <CubeIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
        },
      ],
      submenuLayout: "double",
    },
    {
      label: "DeFi",
      href: "/defi",
    },
    {
      label: "Portfolio",
      sendEvent: () => {
        trackEvent(HEADER_NAV_CLICK, {
          nav_item: "portfolio",
          location: "header",
        });
      },
      submenu: [
        {
          label: "My rewards",
          description: "View your dashboard",
          href: "/dashboard",
          icon: (
            <ChartPieIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent(HEADER_NAV_CLICK, {
              nav_item: "portfolio",
              sub_item: "my_rewards",
              location: "header",
            });
          },
        },
        {
          label: "Claim token",
          description: "Claim your airdrop quickly and securely",
          href: "/claim-token",
          icon: (
            <HandArrowDownIcon
              weight="fill"
              color="black"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent(HEADER_NAV_CLICK, {
              nav_item: "portfolio",
              sub_item: "claim_token",
              location: "header",
            });
          },
        },
        {
          label: "Stake $KERNEL",
          description: "Stake $KERNEL to participate in governance",
          href: "https://kerneldao.com/stake/",
          external: true,
          icon: (
            <img
              src={LOGOS.KernelDaoOutlined.src}
              alt="Kelp"
              className="w-4 h-4 lg:w-6 lg:h-6"
            />
          ),
          sendEvent: () => {
            trackEvent(HEADER_NAV_CLICK, {
              nav_item: "portfolio",
              sub_item: "stake_kernel",
              location: "header",
            });
          },
        },
      ],
      submenuLayout: "double",
      submenuFooter: (
        <Socials
          platformIconWidth={12}
          platformIconHeight={12}
          size={24}
          socials={[
            {
              key: SocialKeys.TWITTER,
              link: "https://x.com/kernel_dao",
              platformKey: PlatformKeys.KERNEL,
              sendEvent: () => {
                trackEvent(HEADER_NAV_CLICK, {
                  nav_item: "social",
                  platform: "x",
                  location: "header",
                });
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "x",
                  location: "header",
                  destination_url: "https://x.com/kernel_dao",
                });
              },
            },
            {
              key: SocialKeys.TWITTER,
              link: "https://x.com/KelpDAO",
              platformKey: PlatformKeys.KELP,
              sendEvent: () => {
                trackEvent(HEADER_NAV_CLICK, {
                  nav_item: "social",
                  platform: "x",
                  location: "header",
                });
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "x",
                  location: "header",
                  destination_url: "https://x.com/KelpDAO",
                });
              },
            },
            {
              key: SocialKeys.DISCORD,
              link: "https://discord.gg/khSpqCFvGq",
              sendEvent: () => {
                trackEvent(HEADER_NAV_CLICK, {
                  nav_item: "social",
                  platform: "discord",
                  location: "header",
                });
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "discord",
                  location: "header",
                  destination_url: "https://discord.gg/khSpqCFvGq",
                });
              },
            },
            {
              key: SocialKeys.TELEGRAM,
              link: "https://t.me/KelpDAOxyz/",
              sendEvent: () => {
                trackEvent(HEADER_NAV_CLICK, {
                  nav_item: "social",
                  platform: "telegram",
                  location: "header",
                });
                trackEvent("lp_social_click", {
                  event_type: "button_click",
                  event_category: "Landing",
                  platform: "telegram",
                  location: "header",
                  destination_url: "https://t.me/KelpDAOxyz/",
                });
              },
            },
          ]}
        />
      ),
    },
  ];
};

export const useKelpAppMenuItems = (appType: string): ActionMenuItem[] => {
  return [
    {
      id: "kelp",
      label: "Kelp",
      icon: <img src={FAVICONS.Kelp.src} alt="Kelp" className="w-7 h-7" />,
      action: () => {
        trackEvent("lp_product_selected", {
          event_type: "button_click",
          event_category: "Landing",
          event_label: "Kelp",
        });
        window.open("https://kerneldao.com/kelp", "_blank");
      },
      selected: appType === "kelp",
    },
    {
      id: "gain",
      label: "Gain",
      icon: <img src={FAVICONS.Gain.src} alt="Gain" className="w-7 h-7" />,
      action: () => {
        trackEvent("lp_product_selected", {
          event_type: "button_click",
          event_category: "Landing",
          event_label: "Gain",
        });
        window.open("https://kerneldao.com/gain", "_blank");
      },
      selected: appType === "gain",
    },
    {
      id: "kernel",
      label: "Kernel",
      icon: <img src={FAVICONS.Kernel.src} alt="Kernel" className="w-7 h-7" />,
      action: () => {
        trackEvent("lp_product_selected", {
          event_type: "button_click",
          event_category: "Landing",
          event_label: "Kernel",
        });
        window.open("https://kerneldao.com/kernel", "_blank");
      },
      selected: appType === "kernel",
    },
  ];
};

// Create nav items with three-dot icon as label
export const menuNavItems: NavItem[] = [
  {
    label: (
      <DotsThreeVerticalIcon className="h-[24px] w-[24px]" weight="regular" />
    ),
    sendEvent: () => {
      trackEvent(PRODUCT_DROPDOWN_CTA);
    },
    submenu: [
      {
        label: "Terms and Services",
        href: "/terms-of-service",
        icon: (
          <GavelIcon
            className="h-[24px] w-[24px] text-text-primary"
            weight="fill"
          />
        ),
        external: true,
      },
      {
        label: "Privacy Policy",
        href: "/privacy-policy",
        icon: (
          <ShieldWarningIcon
            className="h-[24px] w-[24px] text-text-primary"
            weight="fill"
          />
        ),
        external: true,
      },
      // {
      //   label: "Risks and Disclaimer",
      //   href: "/risks-disclaimer",
      //   icon: (
      //     <SealWarningIcon
      //       className="h-[24px] w-[24px] text-text-primary"
      //       weight="fill"
      //     />
      //   ),
      // },
    ],
    submenuFooter: (
      <Socials
        platformIconWidth={12}
        platformIconHeight={12}
        size={24}
        socials={[
          {
            key: SocialKeys.TWITTER,
            link: "https://x.com/kernel_dao",
            platformKey: PlatformKeys.KERNEL,
            sendEvent: () => {
              trackEvent(HEADER_NAV_CLICK, {
                nav_item: "social",
                platform: "x",
                location: "header",
              });
            },
          },
          {
            key: SocialKeys.TWITTER,
            link: "https://x.com/KelpDAO",
            platformKey: PlatformKeys.KELP,
            sendEvent: () => {
              trackEvent(HEADER_NAV_CLICK, {
                nav_item: "social",
                platform: "x",
                location: "header",
              });
            },
          },
          {
            key: SocialKeys.DISCORD,
            link: "https://discord.gg/khSpqCFvGq",
            sendEvent: () => {
              trackEvent(HEADER_NAV_CLICK, {
                nav_item: "social",
                platform: "discord",
                location: "header",
              });
            },
          },
          {
            key: SocialKeys.TELEGRAM,
            link: "https://t.me/KelpDAOxyz/",
            sendEvent: () => {
              trackEvent(HEADER_NAV_CLICK, {
                nav_item: "social",
                platform: "telegram",
                location: "header",
              });
            },
          },
        ]}
      />
    ),
  },
];
